import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Paper,
  Radio,
  Table,
  TableContainer,
} from '@mui/material'
import axios from 'axios'
import moment from 'moment'
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { IoCheckmarkDoneSharp } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import {
  deleteTransaction,
  updateCategory,
  updateQuantity,
} from '../../services/transactions'
import './todaysReport.css'
import { MyContext } from '../ContextApi'
const Row = ({ item, index, reload, setRecords, scanActive }) => {
  const [quantity, setQuantity] = useState(0)
  const timeoutIdRef = useRef(null)
  const { getDecryptedSessionItem } = useContext(MyContext)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const quantityInputRef = useRef(null)
  const [isDefaultValue, setIsDefaultValue] = useState(true)

  useEffect(() => {
    // Check localStorage for persisted category, otherwise use server data
    const persistedCategory = localStorage.getItem(`selectedCategory_${item.id}`);
    setSelectedCategory(persistedCategory || item['category']);
    setQuantity(item['quantity']);
    setIsDefaultValue(item['quantity'] === "1");

    if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);

    if (index === 0 && quantityInputRef.current && !scanActive) {
      timeoutIdRef.current = setTimeout(() => {
        if (!scanActive && quantityInputRef.current) {
          quantityInputRef.current.focus();
        }
      }, 0);
    }
    return () => {
      if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
    };
  }, [item, index, scanActive]);

  const onDeleteTransaction = async (id) => {
    const response = await deleteTransaction(id)
    if (response['status'] === 'success') {
      toast.success('successfully deleted transaction')
      setRecords((prev) => prev?.filter((r) => r.id !== id))
    } else {
      toast.error(response['error'])
    }
  }

  const updateQuantityWithDebounce = (value, id) => {
    const debounceDelay = 500

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current)
    }

    timeoutIdRef.current = setTimeout(() => {
      onUpdateQuantity(value, id)
    }, debounceDelay)
  }

  const onUpdateQuantity = async (value, id) => {
    const response = await updateQuantity({
      quantity: value === '' ? '1' : value,
      id,
    })
    if (response['status'] === 'success') {
      toast.success('successfully updated quantities')
    } else {
      toast.error(response['error'])
    }
  }

  const onUpdateCategory = async (category) => {
    const response = await updateCategory({
      new_category: category,
      id: item['id'],
    })

    if (response['status'] === 'success') {
      toast.success('successfully updated Category')
    } else {
      toast.error(response['error'])
    }
  }

  //--------------------- Code for dynamic select options ----------------------

  let values = null
  let options = null

  let genericOptionsMap = new Map([
    ['Expiry', 'expiry'],
    ['Damage', 'damage'],
  ])
  let AlkemOptionsMap = new Map([
    ['Expiry', 'expiry'],
    ['Damage', 'damage'],
    ['Saleable', 'saleable'],
    ['Near Expiry', 'near expiry'],
  ])
  let torrentOptionsMap = new Map([
    ['Expiry', 'expiry'],
    ['Damage', 'damage'],
    ['Saleable', 'saleable'],
  ])

  let lupinOptionMap = new Map([
    ['Expiry', 'expiry'],
    ['Damage', 'damage'],
    ['Over Expiry', 'over-expiry'],
  ])

  let mankindOptionsMap = new Map([
    ['E', 'expiry'],
    ['B', 'damage'],
  ])

  let abbottOptionsMap = new Map([
    ['Expiry', 'expiry'],
    ['Breakage', 'breakage'],
    ['Spoiled', 'spoiled'],
    ['Leakage', 'leakage'],
    ['Loose', 'loose'],
    ['Product Recall', 'productRecall'],
    ['Quality Issue', 'qualityIssue'],
  ])
  let apexOptionsMap = new Map([
    ['Near expiry', 'near expiry'],
    ['Over expiry', 'over-expiry'],
    ['Expiry', 'expiry'],
    ['Damage', 'damage'],
    ['Saleable', 'saleable'],
  ])

  let intasOptionsMap = new Map([['Near expiry', 'near expiry']])

  let bluecrossOptionsMap = new Map([['Over Expiry', 'over-expiry']])

  let zydusOptionsMap = new Map([
    ['Near expiry', 'near expiry'],
    ['Over expiry', 'over-expiry'],
    ['Saleable', 'saleable'],
  ])
   let coronaOptionsMap = new Map([
    ['Near expiry', 'near expiry'],
    ['Saleable', 'saleable'],
  ])
  let macleodsOptionsMap = new Map([
    ['Near expiry', 'near expiry'],
    ['Over expiry', 'over-expiry'],
    ['Saleable', 'saleable'],
  ])
  let alembicOptionsMap = new Map([
    ['Near expiry', 'near expiry'],
    ['Over expiry', 'over-expiry'],
    ['Saleable', 'saleable'],
    ['Spoiled', 'spoiled'],
  ])

  if (
    getDecryptedSessionItem('reportType') === 'mankind' ||
    getDecryptedSessionItem('reportType') === 'mkparekh'
  ) {
    values = mankindOptionsMap
  } else if (getDecryptedSessionItem('reportType') === 'lupin') {
    values = lupinOptionMap
  }
  else if (getDecryptedSessionItem('reportType') === 'alkem') {
    values = AlkemOptionsMap
  }
  else if (getDecryptedSessionItem('reportType') === 'intas') {
    let mergedIntasAndGeneric = new Map([
      ...intasOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedIntasAndGeneric
  } else if (getDecryptedSessionItem('reportType') === 'torrent') {
    let mergedtorrentAndGeneric = new Map([
      ...torrentOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedtorrentAndGeneric
  } else if (getDecryptedSessionItem('reportType') === 'zydus') {
    let mergedIntasAndGeneric = new Map([
      ...zydusOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedIntasAndGeneric
  } else if (getDecryptedSessionItem('reportType') === 'corona') {
    let mergedCoronaAndGeneric = new Map([
      ...coronaOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedCoronaAndGeneric
  } else if (getDecryptedSessionItem('reportType') === 'apex') {
    let mergedapexAndGeneric = new Map([
      ...zydusOptionsMap,
      ...apexOptionsMap,
    ])
    values = mergedapexAndGeneric
  }
  else if (getDecryptedSessionItem('reportType') === 'macleods') {
    let mergedIntasAndGeneric = new Map([
      ...macleodsOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedIntasAndGeneric
  } else if (getDecryptedSessionItem('reportType') === 'alembic') {
    let mergedIntasAndGeneric = new Map([
      ...alembicOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedIntasAndGeneric
  } else if (getDecryptedSessionItem('reportType') === 'abbott') {
    let mergedIntasAndGeneric = new Map([...abbottOptionsMap])
    values = mergedIntasAndGeneric
  } else if (getDecryptedSessionItem('reportType') === 'bluecross') {
    let mergedBluecrossAndGeneric = new Map([
      ...bluecrossOptionsMap,
      ...genericOptionsMap,
    ])
    values = mergedBluecrossAndGeneric
  } else {
    values = genericOptionsMap
  }

  if (values) {
    options = Array.from(values).map(([key, values]) => (
      <option key={values} value={values}>{key}</option>
    ))
    options.push(<option key="" value=""></option>)
  }


  return (
    <tr key={index}>
      <td>{item?.category === 'TOTAL QTY' ? '' : index + 1}</td>
      <td>{item?.['type']}</td>
      <td>{item?.['itemCode']}</td>
      <td>{item['sku']}</td>
      <td>{
        // show obatch returned from server for zydus, otherwise show batch
        getDecryptedSessionItem('reportType')?.toLowerCase() === 'zydus'
          ? item['obatch']
            ? item['obatch']
            : item['batch']
          : item['batch']
      }</td>
      <td>{parseFloat(item['mrp'])}</td>
      <td>
        {moment(item['expiry'], 'MM-YYYY').endOf('month').format('DD/MM/YYYY')}
      </td>
      <td>
        {item['mfg'] === 'nan' ||
          item['mfg'] === 'Invalid date' ||
          item['mfg'] === '' ||
          item['mfg'] === '-NA-'
          ? ''
          : moment(item['mfg'], 'MM-YYYY').endOf('month').format('DD/MM/YYYY')}
      </td>
      <td>{item?.optional2 || ''}</td>
      {item?.category === 'TOTAL QTY' ? (
        <td
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          TOTAL QTY
        </td>
      ) : (
        <td style={{ width: 200 }}>
          <div className="input-group mb-3">
            <select
              className="form-control"
              value={selectedCategory}
              onChange={(e) => {
                const newCategory = e.target.value;
                onUpdateCategory(newCategory);
                setSelectedCategory(newCategory);
                localStorage.setItem(`selectedCategory_${item.id}`, newCategory);
              }}
              disabled={
                getDecryptedSessionItem('reportType') === 'intas' ? true : false
              }
            >
              {options}
            </select>
          </div>
        </td>
      )}
      {item?.category === 'TOTAL QTY' ? (
        <td
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {item?.quantity}
        </td>
      ) : (
        <td style={{ width: 150 }}>
          <div className="input-group mb-3">
            <input
              ref={quantityInputRef}
              style={{ textAlign: 'center' }}
              min={1}
              type="number"
              className="form-control"
              onChange={(e) => {
                const inputValue = e.target.value;
                let newValue = inputValue;

                if (isDefaultValue && quantity === "1") {
                  if (inputValue.startsWith("1") && inputValue.length > 1) {
                    newValue = inputValue.substring(1);
                  }
                  setIsDefaultValue(false);
                }

                setQuantity(newValue);
                updateQuantityWithDebounce(newValue, item.id);
              }}
              value={quantity}
            ></input>
          </div>
        </td>
      )}
      <td>
        {item?.category === 'TOTAL QTY' ? (
          ''
        ) : (
          <button
            onClick={() => onDeleteTransaction(item.id)}
            className="btn btn-sm btn-danger"
          >
            delete
          </button>
        )}
      </td>
    </tr>
  )
}

const TodaysReport = ({ setFocusState, focusState, scanActive }) => {
  
  const safeValue = (val) => {
  if (val === null || val === undefined || val === 'nan' || val === '' || Number.isNaN(val)) {
    return '';
  }
  return val;
};
  const abbottRow = [
    { id: 'breakage', label: 'Breakage' },
    { id: 'spoiled', label: 'Spoiled' },
    { id: 'leakage', label: 'Leakage' },
  ]
  const count = useSelector((state) => state.scanResult.count)
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState('')
  const [row, setRow] = useState([])

  useEffect(() => {
    const timer = setTimeout(() => {
      loadTodaysReport();
    }, 500);

    return () => clearTimeout(timer);
  }, [count]);

  const handleClickListItem = (number) => {
    setOpen(true)

    if (number === 1) {
      setRow([
        { id: 'damage', label: 'Damage' },
        { id: 'near expiry', label: 'Near expiry' },
      ])
    }
    if (number === 2) {
      setRow([
        { id: 'saleable', label: 'Saleable' },
        { id: 'damage', label: 'Damage' },
      ])
    }
    if (number === 3) {
      setRow(abbottRow)
    }
    if (number === 5) {
      // Near Expiry popup - for diffInMonths 2-5
      setRow([
        { id: 'near expiry', label: 'Near expiry' },
        { id: 'damage', label: 'Damage' },
      ])
    }
  }

  const handleClose = (newValue) => {
    if (newValue) {
      setValue(newValue);
    } else if (row?.length > 0) {
      setValue(row[0].id);
    }
    setOpen(false);
  };

  const [records, setRecords] = useState([])
  const [showTick, setShowTick] = useState(false)
  const [length, setLength] = useState('')
  const [division, setDivision] = useState('')
  const [barcode1, setBarcode1] = useState('')
  const { getDecryptedSessionItem } = useContext(MyContext)

  const loadTodaysReport = useCallback(async () => {
    const url = `${getDecryptedSessionItem('server')}/result/${getDecryptedSessionItem('request_id')}`
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Token')}`,
        },
      })
      .then(({ data: response }) => {
        if (response['status'] === 'success') {
          const newData = response.data
          const newLength = newData.length
          const currentMonth = new Date().getMonth() + 1
          const currentYear = new Date().getFullYear()
          // if (sessionStorage['reportType'] === 'zydus') {
          //   console.log('In Todays report component in zydus ')

          //   const today = moment()
          //   console.log('Report Data:', response)
          //   for (let i = 0; i < response?.data?.length; i++) {
          //     const expiry = moment(response?.data[i].expiry, 'MM-YYYY')
          //     const diffMonths = expiry.diff(today, 'months')
          //     console.log('===>', expiry, '\n', diffMonths)
          //     if (diffMonths < -6) {
          //       response.data[i].category = 'over-expiry'
          //     } else if (diffMonths >= -6 && diffMonths < 0) {
          //       response.data[i].category = 'expiry'
          //     } else if (diffMonths >= 0 && diffMonths <= 6) {
          //       if (
          //         response.data[0].category === 'damage' &&
          //         response.data[0].barcode1 !== 'true'
          //       ) {
          //         handleClickListItem(1)
          //       }
          //     } else if (diffMonths >= 0 && diffMonths > 6) {
          //       if (
          //         response.data[0].category === 'damage' &&
          //         response.data[0].barcode1 !== 'true'
          //       ) {
          //         handleClickListItem(2)
          //       }
          //     }
          //   }
          // }


          if (records.length > 0 && newLength > records.length) {
            setShowTick(true)
            setTimeout(() => setShowTick(false), 1000)
          }

          setLength(newLength)
          setDivision(safeValue(newData[0]?.optional2));

          const latestBarcode1 =
            newData.find((row) => row?.barcode1 && row?.barcode1 !== 'nan')?.barcode1 ||
            newData[0]?.barcode1 ||
            '';
          setBarcode1(safeValue(latestBarcode1));

          if (getDecryptedSessionItem('reportType') === 'zydus') {
            let dialogTriggered = false
            for (let i = 0; i < newData?.length; i++) {
              const expiryDateMonth = Number(newData[i].expiry?.split('-')[0])
              const expiryDateYear = Number(newData[i].expiry?.split('-')[1])
              const diffInMonths =
                (expiryDateYear - currentYear) * 12 +
                (expiryDateMonth - currentMonth)

              let calculatedCategory = null
              if (diffInMonths <= 1) {
                calculatedCategory = 'expiry'
              } else if (diffInMonths >= 2 && diffInMonths <= 5) {
                calculatedCategory = 'near expiry'
              } else if (diffInMonths >= 6) {
                calculatedCategory = 'saleable'
              }

              // Save calculated category to database for items not yet confirmed
              if (calculatedCategory && newData[i].category_update === 'false') {
                if (newData[i].category !== calculatedCategory) {
                  newData[i].category = calculatedCategory
                  updateCategory({
                    new_category: calculatedCategory,
                    id: newData[i].id,
                  })
                } else {
                  newData[i].category = calculatedCategory
                }
              }

              // Trigger dialog popup for saleable items only
              if (!dialogTriggered && newData[i].category_update === 'false' && !(newData[i].barcode1 === 'true')) {
                if (diffInMonths >= 6) {
                  // Saleable: offer saleable, damage options
                  handleClickListItem(2)
                  dialogTriggered = true
                }
              }
            }
          }

          if (getDecryptedSessionItem('reportType') === 'corona') {
            for (let i = 0; i < newData?.length; i++) {
              const expiryDateMonth = Number(newData[i].expiry?.split('-')[0])
              const expiryDateYear = Number(newData[i].expiry?.split('-')[1])
              const diffInMonths =
                (expiryDateYear - currentYear) * 12 +
                (expiryDateMonth - currentMonth)

              let calculatedCategory = null
              if (diffInMonths <= 1) {
                calculatedCategory = 'expiry'
              } else if (diffInMonths >= 2 && diffInMonths <= 5) {
                calculatedCategory = 'near expiry'
              } else if (diffInMonths >= 6) {
                calculatedCategory = 'saleable'
              }

              if (calculatedCategory && newData[i].category_update === 'false') {
                if (newData[i].category !== calculatedCategory) {
                  newData[i].category = calculatedCategory
                  updateCategory({
                    new_category: calculatedCategory,
                    id: newData[i].id,
                  })
                } else {
                  newData[i].category = calculatedCategory
                }
              }
            }
          }

          if (getDecryptedSessionItem('reportType') === 'macleods') {
            const newMonth = currentMonth + 6

            for (let i = 0; i < newData?.length; i++) {
              const expiryDateMonth = Number(newData[i].expiry?.split('-')[0])
              const expiryDateYear = Number(newData[i].expiry?.split('-')[1])
              const monthsDifference =
                (currentYear - expiryDateYear) * 12 +
                (currentMonth - expiryDateMonth)

              if (monthsDifference > 6) {
                newData[i].category = 'over-expiry'
              } else if (monthsDifference >= 0) {
                newData[i].category = 'expiry'
              }

              if (newData[i].category_update === 'false') {
                if (
                  expiryDateYear > currentYear &&
                  !(newData[i].barcode1 === 'true')
                ) {
                  if (newMonth > 12) {
                    if (
                      Math.abs(monthsDifference) > 0 &&
                      Math.abs(monthsDifference) <= 3
                    ) {
                      if (
                        newData[i].category === 'damage' &&
                        !(newData[i].barcode1 === 'true')
                      ) {
                        handleClickListItem(1)
                      }
                    } else if (Math.abs(monthsDifference) > 3) {
                      if (
                        newData[i].category === 'damage' &&
                        !(newData[i].barcode1 === 'true')
                      ) {
                        handleClickListItem(2)
                      }
                    }
                  } else {
                    if (
                      !(newData[i].barcode1 === 'true') &&
                      expiryDateYear > currentYear
                    ) {
                      handleClickListItem(2)
                    }
                  }
                }

                if (
                  currentYear === expiryDateYear &&
                  !(newData[i].barcode1 === 'true')
                ) {
                  if (
                    Math.abs(monthsDifference) > 0 &&
                    Math.abs(monthsDifference) <= 3
                  ) {
                    if (newData[i].category === 'damage') {
                      handleClickListItem(1)
                    }
                  }

                  if (Math.abs(monthsDifference) > 3) {
                    if (newData[i].category === 'damage') {
                      handleClickListItem(2)
                    }
                  }
                }
              }
            }
          }

          if (getDecryptedSessionItem('reportType') === 'intas') {
            const nearExpiryMonth = currentMonth + 2

            for (let i = 0; i < newData?.length; i++) {
              const expiryDateMonth = Number(newData[i].expiry?.split('-')[0])
              const expiryDateYear = Number(newData[i].expiry?.split('-')[1])

              if (currentYear == expiryDateYear) {
                if (currentMonth == expiryDateMonth) {
                  newData[i].category = 'expiry'
                } else if (
                  expiryDateMonth > currentMonth &&
                  expiryDateMonth <= nearExpiryMonth
                ) {
                  newData[i].category = 'near expiry'
                }
              }

              newData[i].category =
                newData[i].category === 'near expiry'
                  ? 'near expiry'
                  : newData[i].category === 'over-expiry' ||
                    newData[i].category === 'expiry'
                    ? 'expiry'
                    : 'damage'
            }
          }
          if (getDecryptedSessionItem('reportType') === 'alkem') {
            // Alkem rules (comparing full month-year):
            // - Expiry: expiryDate <= current month-year (Nov-25 = Expiry)
            // - Near Expiry: expiryDate in next 2 months (Dec-25 + Jan-26 = Near Expiry)
            // - Saleable: expiryDate from 3 months onwards (Feb-26+ = Saleable)

            for (let i = 0; i < response?.data?.length; i++) {
              const expiryDateMonth = Number(
                response?.data[i].expiry?.split('-')[0]
              );
              const expiryDateYear = Number(
                response?.data[i].expiry?.split('-')[1]
              );

              // Calculate the expiry date as a number for easy comparison: year*12 + month
              const expiryDateValue = expiryDateYear * 12 + expiryDateMonth;
              const currentDateValue = currentYear * 12 + currentMonth;

              // Next 2 months range
              const nearExpiryStartValue = currentDateValue + 1;
              const nearExpiryEndValue = currentDateValue + 2;

              if (expiryDateValue <= currentDateValue) {
                // Expiry: current month and earlier (till current month)
                response.data[i].category = 'expiry';
              } else if (
                expiryDateValue >= nearExpiryStartValue &&
                expiryDateValue <= nearExpiryEndValue
              ) {
                // Near Expiry: next 1-2 months
                response.data[i].category = 'near expiry';
              } else {
                // Saleable: 3 months and beyond
                response.data[i].category = 'saleable';
              }
            }
          }
          if (getDecryptedSessionItem('reportType') === 'apex') {
            // console.log("In Todays report component in zydus ");

            const newMonth = currentMonth + 6

            for (let i = 0; i < response?.data?.length; i++) {
              // console.log("All Data :", response.data);
              // console.log(
              //   "response.data[i].category_update",
              //   response.data[i].category_update
              // );
              const expiryDateMonth = Number(
                response?.data[i].expiry?.split('-')[0]
              )

              const expiryDateYear = Number(
                response?.data[i].expiry?.split('-')[1]
              )
              const monthsDifference =
                (currentYear - expiryDateYear) * 12 +
                (currentMonth - expiryDateMonth)
              if (monthsDifference > 6) {
                response.data[i].category = 'over-expiry'
              } else if (monthsDifference >= 0) {
                response.data[i].category = 'expiry'
              }

              response.data[i].category =
                response?.data[i].category === 'near expiry'
                  ? 'near expiry'
                  : response?.data[i].category === 'over-expiry' || response?.data[i].category === 'expiry'
                    ? 'expiry'
                    : response?.data[i].category === 'saleable'
                      ? 'saleable'
                      : 'damage';


            }
          }

          if (getDecryptedSessionItem('reportType') === 'torrent') {
            for (let i = 0; i < newData?.length; i++) {
              newData[i].category =
                newData[i].category === 'near expiry'
                  ? 'near expiry'
                  : newData[i].category === 'over-expiry' || newData[i].category === 'expiry'
                    ? 'expiry'
                    : newData[i].category === "saleable"
                      ? 'saleable'
                      : 'damage';
            }
          }

          if (getDecryptedSessionItem('reportType') === 'lupin') {
            const nearExpiryMonth = currentMonth + 2
            const SIXExpiryMonth = currentMonth - 6

            for (let i = 0; i < newData?.length; i++) {
              const expiryDateMonth = Number(newData[i].expiry?.split('-')[0])
              const expiryDateYear = Number(newData[i].expiry?.split('-')[1])

              if (currentYear == expiryDateYear) {
                if (currentMonth == expiryDateMonth) {
                  newData[i].category = 'expiry'
                } else if (
                  expiryDateMonth > currentMonth &&
                  expiryDateMonth <= nearExpiryMonth
                ) {
                  newData[i].category = 'expiry'
                }
                else if (
                  expiryDateMonth <= SIXExpiryMonth
                ) {
                  newData[i].category = 'over-expiry'
                }
              }

              newData[i].category =
                newData[i].category === 'over-expiry'
                  ? 'over-expiry'
                  : newData[i].category === 'expiry'
                    ? 'expiry'
                    : 'damage'
            }
          }

          if (getDecryptedSessionItem('reportType') === 'abbott') {
            for (let i = 0; i < newData?.length; i++) {
              if (newData[i].category_update === 'false') {
                const now = moment()
                const transactionDate = moment(newData[i].expiry, 'MM-YYYY')
                const threeMonthsFromNow = now.clone().add(2, 'months')

                if (transactionDate.isBefore(threeMonthsFromNow)) {
                  newData[i].category = 'expiry'
                } else {
                  handleClickListItem(3)
                }
              }
            }
          }

          if (getDecryptedSessionItem('reportType') === 'bluecross') {
            for (let i = 0; i < newData?.length; i++) {
              const expiryDateMonth = Number(newData[i].expiry?.split('-')[0])
              const expiryDateYear = Number(newData[i].expiry?.split('-')[1])
              const assumedExpiryMonth = currentMonth + 5

              if (currentYear > expiryDateYear) {
                newData[i].category = 'expiry'
              } else if (currentYear === expiryDateYear) {
                if (
                  (currentMonth < expiryDateMonth && expiryDateMonth <= assumedExpiryMonth) ||
                  currentMonth >= expiryDateMonth
                ) {
                  newData[i].category = 'expiry'
                } else {
                  newData[i].category = 'damage'
                }
              } else if (currentYear < expiryDateYear) {
                if (assumedExpiryMonth > 12) {
                  if (assumedExpiryMonth % 12 > expiryDateMonth) {
                    newData[i].category = 'expiry'
                  } else {
                    newData[i].category = 'damage'
                  }
                }
                newData[i].category = 'damage'
              }
            }
          }

          if (
            getDecryptedSessionItem('reportType') === 'mankind' ||
            getDecryptedSessionItem('reportType') === 'mkparekh'
          ) {
            const nearExpiryMonth = currentMonth + 2

            for (let i = 0; i < newData?.length; i++) {
              const expiryDateMonth = Number(newData[i].expiry?.split('-')[0])
              const expiryDateYear = Number(newData[i].expiry?.split('-')[1])

              if (currentYear > expiryDateYear) {
                newData[i].category = 'expiry'
              }

              if (currentYear < expiryDateYear) {
                newData[i].category = 'damage'

                if (nearExpiryMonth > 12) {
                  if (nearExpiryMonth % 12 > expiryDateMonth) {
                    newData[i].category = 'expiry'
                  } else {
                    newData[i].category = 'damage'
                  }
                }
              }

              if (currentYear === expiryDateYear) {
                if (nearExpiryMonth >= expiryDateMonth) {
                  newData[i].category = 'expiry'
                } else {
                  newData[i].category = 'damage'
                }
              }
            }
          }

          setRecords(newData)
        } else {
          toast.error(response['error'])
        }
      })
  }, [count, getDecryptedSessionItem, records.length]);

  useEffect(() => {
    ; (async () => {
      if (value !== '') {
        const response = await updateCategory({
          new_category: value,
          id: records[0]?.id,
        })

        if (response['status'] === 'success') {
          toast.success('successfully updated Category')
          const updatedBarcode1 = records[0]?.barcode1 || ''
          setRecords((prev) => {
            if (!prev || prev.length === 0) return prev
            return [
              { ...prev[0], category: value, barcode1: updatedBarcode1 },
              ...prev.slice(1),
            ]
          })
          setBarcode1(updatedBarcode1)
          setValue('')
        } else {
          toast.error(response['error'])
        }
      }
    })()
  }, [value, records])

  return (
    <div>
      <div>
        <ConfirmationDialog
          id="ringtone-menu"
          keepMounted
          open={open}
          onClose={handleClose}
          value={value}
          rows={row}
        />
        {showTick && (
          <div className="tick-icon">
            <div className="tick-icon-inner">
              <IoCheckmarkDoneSharp
                style={{
                  fontSize: '50px',
                  color: 'white',
                }}
              />
            </div>
            <div className="barcode-text">
              {
                getDecryptedSessionItem('reportType') === 'zydus' ?
                  barcode1 || ''
                  : division || ''
              }
            </div>
          </div>
        )}
        <Divider />
        <table className="table table-striped" style={{ minWidth: 1000 }}>
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Item Code</th>
              <th>Product Name</th>
              <th>Batch Number</th>
              <th>MRP</th>
              <th>Expiry Date</th>
              <th>Mfg Date</th>
              <th>Division</th>
              <th>Category</th>
              <th>Quantities</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {records.map((item, index) => {
              return (
                <Row
                  item={item}
                  index={index}
                  key={index}
                  setRecords={setRecords}
                  scanActive={scanActive}
                  focusState={focusState}
                />
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TodaysReport

function ConfirmationDialog({ onClose, open, rows = [], ...other }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const count = useSelector((state) => state.scanResult.count);
  const radioRefs = useRef([]);
  useEffect(() => {
    if (open && rows.length > 0) {
      setSelectedIndex(0);
      setTimeout(() => {
        radioRefs.current[0]?.focus();
      }, 150);
    }
  }, [open, rows]);

  const handleDialogClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      onClose(null);
    } else {
      onClose(rows[selectedIndex]?.id);
    }
  };
  useEffect(() => {
    if (open && count > 0) {
      onClose(rows[selectedIndex]?.id);
    }
  }, [count]);

  const handleSelect = (index) => {
    setSelectedIndex(index);
    onClose(rows[index].id);
  };

  const handleKeyDown = (e, index) => {
    if (!rows.length) return;

    let newIndex = index;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        newIndex = (index + 1) % rows.length;
        setSelectedIndex(newIndex);
        radioRefs.current[newIndex]?.focus();
        break;

      case "ArrowUp":
        e.preventDefault();
        newIndex = (index - 1 + rows.length) % rows.length;
        setSelectedIndex(newIndex);
        radioRefs.current[newIndex]?.focus();
        break;

      case "Enter":
      case " ":
        e.preventDefault();
        handleSelect(index);
        break;

      case "Escape":
        e.preventDefault();
        onClose(null);
        break;

      default:
        if (/^[1-9]$/.test(e.key)) {
          const numIndex = parseInt(e.key, 10) - 1;
          if (numIndex >= 0 && numIndex < rows.length) {
            e.preventDefault();
            setSelectedIndex(numIndex);
            radioRefs.current[numIndex]?.focus();
            handleSelect(numIndex);
          }
        }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      {...other}
      maxWidth="xs"
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "72%",
          maxHeight: "72%",
        },
      }}
    >
      <DialogTitle>Please select category</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            {rows.map((row, index) => (
              <div
                key={row.id}
                ref={(el) => (radioRefs.current[index] = el)}
                tabIndex={0}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onClick={() => handleSelect(index)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  outline: "none",
                  padding: "8px 10px",
                  borderRadius: 6,
                  cursor: "pointer",
                  backgroundColor:
                    selectedIndex === index ? "#e3f2fd" : "transparent",
                  transition: "background-color 0.2s ease",
                }}
              >
                <Radio
                  checked={selectedIndex === index}
                  value={row.id}
                  color="primary"
                />
                <div>{row.label}</div>
              </div>
            ))}
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}
